import request from "@/utils/request";
import { Local } from "@/utils/storage";

//重置用户密码
export function resetUserPwd(uid:any){
    let path = "/api/user/resetPwd"
    let param = {
        userId: uid
    }
    return request.post(path,param)
}

//获取用户信息
export function getUserInfo(uid:any){
    let path = "/api/user/getInfo"
    let param = {
        userId: uid
    }
    return request.get(path,param)
}

//资产数据
export function getUserAssets(uid:any){
    let path = "/api/user/assetsCounts"
    let param = {
        userId: uid
    }
    return request.get(path,param)
}

//用户会员卡
export function getUserCards(uid:any){
    let path = "/api/user/member/cards"
    let param = {
        userId: uid
    }
    return request.get(path,param)
}



export function setCarbon(data:any){
    let path = "/api/admin/carbon/balance"

    return request.post(path,data)
}

export function setConsume(data:any){
    let path = "/api/admin/consume/balance"

    return request.post(path,data)
}

export function setInvent(data:any){
    let path = "/api/admin/invent/balance"

    return request.post(path,data)
}


export function setGiftCards(data:any){
    let path = "/api/admin/gift/cards"

    return request.post(path,data)
}

export function indexStatistics(){
    let path = "/api/admin/statistics"

    return request.get(path,{})
 }

export function mecOrderEcharts(data:any){
    let path = "/api/admin/order/revenue/chart"

    return request.post(path,data)
 }

 export function mecTypePrice(data:any){
    let path = "/api/admin/order/revenue/byType"

    return request.post(path,data)

 }
 


 export function getPayChannel(){
    let path = "/api/pay/channel"

    return request.get(path,{})

 }

 export function setPayChannel(data:any){
    let path = "/api/pay/channel/set"

    return request.get(path,{type: data})

 }


 export function updateFeedback(data:any){
    let path = "/api/admin/feedback/update"
    return request.post(path,data)
}

// 角色管理相关接口
// 获取角色列表
export function getRoleList(data?:any){
    let path = "/api/role/page"
    return request.get(path, data)
}

// 添加角色
export function addRole(data:any){
    let path = "/api/role/create"
    return request.post(path, data)
}

export function getPermissionList(data:any){
    let path = "/api/permission/tree"
    return request.get(path, data)
}

export function getRolePermissions(id:any){
    let path = "/api/permission/listByRole/"+id
    return request.get(path, {})
}

export function addPermission(data:any){
    let path = "/api/permission/create"
    return request.post(path, data)
}

export function updatePermission(data:any){
    let path = "/api/permission/update"
    return request.post(path, data)
}

export function getPermissionTopList(){
    let path = "/api/permission/list"
    return request.get(path, {})
}


// 更新角色
export function updateRole(data:any){
    let path = "/api/role/update"
    return request.post(path, data)
}

// 删除角色
export function deleteRole(id:any){
    let path = "/api/role/delete"
    let param = {
        id: id
    }
    return request.post(path, param)
}

// 获取角色详情
export function getRoleDetail(id:any){
    let path = "/api/role/detail"
    let param = {
        id: id
    }
    return request.get(path, param)
}

 export function userUpdate(data:any){
    let path = "/api/user/update"

    return request.post(path,data)

 }


 export function addUser(data:any){
    let path = "/api/user/add"

    return request.post(path,data)

 }

//副卡，亲情卡数量
 export function queryUserShareableCard(id:any){
    let path = "/api/user/detail/shareable"

    return request.get(path,{userId: id})

 }


 export function updateInivteBind(data:any){
    let path = "/api/card/invitation/bind"

    return request.post(path,data)

 }


 export function cancelInivteBind(data:any){
    let path = "/api/card/invitation/cancel"

    return request.post(path,data)

 }


 export function updateCarbonStatus(data:any){
    let path = "/api/admin/carbon/status"

    return request.post(path,data)
}

export function getAdminPermissions(){
    let adminId = Local.get("managerInfo").id
    let path = "/api/admin/permissions/"+adminId

    return request.get(path,{})
}

export function addAdmin(data:any){
    let path = "/api/admin/create"

    return request.post(path, data)
}

export function updateAdmin(data:any){
    let path = "/api/admin/update"

    return request.post(path, data)
}

export function getAllRoles(){
    let path = "/api/role/list"

    return request.get(path,{})
}


export function resetAdminPwd(name:any){
    let path = "/api/admin/rp"

    return request.get(path,{adminId: name})
}


export function getUserAddress(userId:any){
    let path = "/api/user/address/list"

    return request.post(path,{userId})
}

// 获取用户推广收益统计
export function getUserPerformanceStat(userId:any){
    let path = "/api/userPerformLog/stat"
    let param = {
        userId: userId
    }
    return request.post(path, param)
}

// 编辑用户推广收益（增加或扣除）
export function editUserPerformance(data:any){
    let path = "/api/userPerformLog/edit"
    return request.post(path, data)
}
